import './styles/swaps.css';
import { useGameStore } from '../../store/gameStore';
import { useShallow } from 'zustand/shallow';
import Tile from '../subcomponents/Tile';
import { useEffect } from 'react';

function Swaps() {
  // Subscribe to game store
  const { mode, swapCount, setGameEnded } = useGameStore(
    useShallow((state) => ({
      mode: state.mode,
      swapCount: state.gameData[state.mode].swapCount,
      setGameEnded: state.setGameEnded,
    }))
  );

  const getSwapsText = () => {
    const isBlitz = mode.includes('blitz');
    if (isBlitz) {
      return 'SWAPS';
    } else {
      return 'SWAPS REMAINING';
    }
  };

  useEffect(() => {
    if (swapCount === 0) setGameEnded();
  }, [swapCount]);

  return (
    <div className="swaps-container">
      <div className="swaps-wrapper">
        <div className="swaps-text">{getSwapsText()}</div>
        <Tile
          id="swap-tile"
          small
          green={swapCount > 2}
          red={swapCount <= 2}
          value={swapCount.toLocaleString()}
        />
      </div>
    </div>
  );
}

export default Swaps;
